import { FormTemplate } from "components/modal/templates";
import React from "react";
import { apply, getItem } from "sources/books/counterpartyGroups";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateCounterpartyGroupModal extends FormTemplate {
    componentDidMount() {
        const initial = this.props.initialState ? this.props.initialState : {};
        const { id } = this.props;
        if (id) {
            getItem({ id }).then((data) => this.setState({ isLoading: false, isValid: true, ...initial, ...data }));
        } else {
            this.setState({ isLoading: false, isValid: true, ...initial });
        }
    }

    sendRequest = (stateData) => apply(stateData);

    renderBodyInner = () => {
        const { config } = this.props;
        return <Markup {...config} renderField={this.renderField} />;
    };
}

const ConfiguredModal = (props) => (
    <CreateCounterpartyGroupModal {...props} config={config} initialState={initialState} />
);

export default ConfiguredModal;
